import { render, staticRenderFns } from "./AksesNotifikasi.vue?vue&type=template&id=2d139e3e"
import script from "./AksesNotifikasi.vue?vue&type=script&lang=js"
export * from "./AksesNotifikasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports